import React, { useMemo } from 'react';
import { LabelStyled } from './styled';
import { Marker } from '../marker';
const colorMap = {
    primary: { color: 'primary', markerColor: 'primary' },
    success: { color: 'success', markerColor: 'success' },
    warning: { color: 'warning', markerColor: 'warning' },
    danger: { color: 'danger', markerColor: 'danger' },
    neutral: { color: 'onBackground', markerColor: 'onSurface' },
    onSurface: { color: 'onBackground', markerColor: 'onSurface' },
    link: { color: 'link', markerColor: 'link' },
    linkVisited: { color: 'linkVisited', markerColor: 'linkVisited' }
};
export const Label = ({ marker, withMarker = true, color = 'neutral', text, contrast = false, type = 'label' }) => {
    const markerColor = useMemo(() => {
        if (marker === null || marker === void 0 ? void 0 : marker.color) {
            return colorMap[marker.color].markerColor;
        }
        return colorMap[color].markerColor;
    }, [marker, color]);
    const markerPosition = useMemo(() => {
        var _a;
        return ({
            vertical: 'center',
            horizontal: (_a = marker === null || marker === void 0 ? void 0 : marker.position) !== null && _a !== void 0 ? _a : 'left'
        });
    }, [marker]);
    const showMarker = useMemo(() => {
        return withMarker && !contrast && type === 'label';
    }, [withMarker, contrast, type]);
    return (React.createElement(LabelStyled, { "$color": colorMap[color].color, "$withMarker": withMarker, "$marker": markerPosition, "$contrast": contrast, "$type": type },
        React.createElement("span", null, type === 'label' ? text.toUpperCase() : text),
        showMarker && React.createElement(Marker, { color: markerColor, position: markerPosition, inLabel: true })));
};
